import { Component, OnDestroy, OnInit, OnChanges, SimpleChanges, ViewChild, Input, ChangeDetectorRef } from '@angular/core';
import { BaseComponent } from '../base/base.component';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService, BaseService, PatientService } from '../../services';
import { DialogComponent } from '../dialog/dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { DatePipe } from '@angular/common';
import { MatSelect } from '@angular/material/select';
import { PatientDataboxListComponent } from '../patient-databox-list/patient-databox-list.component';
import { HttpClient, HttpParams } from '@angular/common/http';
import { interval, Subscription } from 'rxjs';
import { IdleStateService } from 'src/app/services/idle-state.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
})
export class DashboardComponent implements OnInit, OnDestroy {
  @ViewChild(MatSelect) matSelect: MatSelect;
  navigationUrl: string;
  updatedTime: any;
  isDropdownOpen: boolean = false;
  activeDropdown: string = '';
  @Input() dataToDisplay: any = [];
  displayTimeline: boolean = false;
  checkboxValue: boolean = false;
  token: any;
  hubidselection: any = [];
  private dataSubscription: Subscription;
  dataStatus: any = [
    { name: 'Sending Data', selected: false },
    { name: 'No Data', selected: false },
  ]
  selectedDataCheckboxes: number = 0;
  selectedRiskCheckboxes: number = 0;
  riskStatus: any = [
    { name: 'No Data', selected: false },
    { name: 'Out Of Bed', selected: false },
    { name: 'No Risk', selected: false },
    { name: 'Mid Risk', selected: false },
    { name: 'High Risk', selected: false },
  ]
  selectedItems: any[] = [];
  hubidData: any[];
  // Ward filter ("View by Ward"): base view applied before Data/Risk filters.
  wardOptions: any[] = [];
  selectedWardStatusCheckboxes: any[] = [];
  selectedWardCheckboxes: number = 0;
  wardFilters: any;
  wardRestoreApplied: boolean = false;
  @Input() timelineId;

  data: any[] = [];
  currentPage = 1;
  itemsPerPage = 10;
  pagesArray: number[] = [];
  sortColumn: any;
  sortOrder: any;
  filterColumn: any;
  filterKey: any;
  selectedDataStatusCheckboxes: any[] = [];
  selectedRiskStatusCheckboxes: any[] = [];
  paginatedData: any;
  filtersApplied: boolean = false;
  filterParams: any = {};
  sortParams: any = {};
  totalRows: any;
  isDialogOpen: boolean = true;
  storedCheckboxState: any;
  graphItemDisplay: any;
  formattingTime: any;
  previousFilterParams: any = {};
  previousSortParams: any = {};
  displayTimelineGraph: any;
  dataLoader: boolean = true;
  isHovered = false;
  isArrowClicked: boolean = false;
  routerStateSnapshot: any;
  dataFilters: any;
  riskFilters: any;
  hubIdHighlighted: 'asc' | 'desc' | null = null;
  wardHighlighted: 'asc' | 'desc' | null = null;
  BedHighlighted: 'asc' | 'desc' | null = null;
  dataHighlighted: 'asc' | 'desc' | null = null;
  riskHighlighted: 'asc' | 'desc' | null = null;
  isDataRestored: boolean = false;
  idleSubscription: Subscription;
  autoTime: any = 5;
  selectUnpiar: any;
  unPairHub_id: any[] = [];
  lang: any;

  constructor(private router: Router,
    public datepipe: DatePipe,
    public activeRoute: ActivatedRoute,
    public auth: AuthService,
    public dialog: MatDialog,
    private patientService: PatientService,
    private baseService: BaseService,
    private translate: TranslateService,
    private idleService: IdleStateService) {
    this.routerStateSnapshot = this.router.routerState.snapshot;
    this.dataToDisplay = []
    this.lang = localStorage.getItem('lang') || 'en';
    this.translate.onLangChange.subscribe((event) => {
      this.lang = event.lang;
    });
  }

  ngOnInit(): void {
    window.addEventListener('storage', (e) => {
      if (e.key === 'base_org') {
        if (!this.router.url.includes(e.newValue)) {
          window.location.href = `/${e.newValue}/dashboard`;
        }
      }
    })
    let existDomain = window.location.href.split("/")[3];
    let baseDoamin = localStorage.getItem('base_org');

    if (existDomain != baseDoamin) {
      this.router.navigateByUrl('/login')
    }

    this.displaydashboardData();
    this.patientService.logoutEvent.subscribe(() => {
      this.isDropdownOpen = false;
    });
  }
  
  translateRiskStatus(riskStatus: string): string {
    let riskstatus = [
      "At left position for",
      "At right position for",
      "At supine position for",
      "Out Of Bed for",
      "No Data for"
    ];

    let match = riskstatus.find(key => riskStatus.startsWith(key));
    if (match) {
      let timePart = riskStatus.slice(match.length).trim(); // gets "02:29"
      let translatedKey = this.translate.instant(match);    // translates "At left position for"
      return `${translatedKey} ${timePart}`;                  // returns "ในตำแหน่งซ้ายสำหรับ 02:29"
    }
    // If no match, return original
    return riskStatus;
  }
  handlePageHover(isHovered: boolean) {
    this.isHovered = isHovered;
  }
  handleArrowClick() {
    this.isArrowClicked = !this.isArrowClicked;
  }

  restoreCheckboxStates(): void {
    if (this.auth.isTokenValid()) {
      this.storedCheckboxState = JSON.parse(localStorage.getItem('checkboxState')) || {};
      this.displayTimelineGraph = JSON.parse(localStorage.getItem('visualizeClickedObj')) || {};
      let storedDataFilters = JSON.parse(localStorage.getItem('selectedDataFilters')) || {};
      let storedRiskFilters = JSON.parse(localStorage.getItem('selectedRiskFilters')) || {};
      let storedSortingParams = JSON.parse(localStorage.getItem('sortingData')) || {}

      this.data = this.data.map(item => {
        item.selected = this.storedCheckboxState[item.patient_number] || false;
        if (item.selected && this.displayTimelineGraph[item.patient_number] && this.displayTimelineGraph[item.patient_number].isSelected) {
          this.displayGraph();
        }
        return item;
      });
      if (this.isDataRestored) {
        return;
      }
      this.dataStatus = this.dataStatus.map(item => {
        item.selected = storedDataFilters[item.name] || false;
        return item;
      });

      this.riskStatus = this.riskStatus.map(item => {
        item.selected = storedRiskFilters[item.name] || false;
        return item;
      });
      this.selectedDataStatusCheckboxes = this.dataStatus.filter(item => item.selected);
      this.selectedRiskStatusCheckboxes = this.riskStatus.filter(item => item.selected);

      if (this.selectedDataStatusCheckboxes.length > 0) {
        this.filterData('datastatus', this.selectedDataStatusCheckboxes);
        this.selectedDataCheckboxes = this.selectedDataStatusCheckboxes.length;
      }
      if (this.selectedRiskStatusCheckboxes.length > 0) {
        this.filterData('risk_type', this.selectedRiskStatusCheckboxes);
        this.selectedRiskCheckboxes = this.selectedRiskStatusCheckboxes.length;
      }
      this.isDataRestored = true;
      if (Object.keys(storedSortingParams).length > 0) {
        const { sortcolumn, sortorder } = storedSortingParams;

        this.sortingData(sortcolumn, sortorder);
      }
    } else {
      this.auth.refreshToken();
    }

  }

  setupAutomaticRefresh() {
    if (this.auth.isTokenValid()) {
      if (this.dataSubscription) {
        this.dataSubscription.unsubscribe();
      }
      // Set up a periodic timer to refresh data every 5 minutes (300,000 milliseconds).
      let refreshTimer = JSON.parse(localStorage.getItem('autoRefresh'));
      if (refreshTimer) {
        this.dataSubscription = interval(refreshTimer * 60 * 1000).subscribe(() => {
          this.displaydashboardData();
        });
      } else {
        this.dataSubscription = interval(this.autoTime * 60 * 1000).subscribe(() => {
          this.displaydashboardData();
        });
      }
    } else {
      this.auth.refreshToken();
    }
  }
  onCheckboxChange(item: any) {
    if (this.auth.isTokenValid) {
      if (!item.selected) {
        item.isSelected = false;
        item.timelineGraphData = null;
        this.displayTimeline = false;

        this.storedCheckboxState = JSON.parse(localStorage.getItem('checkboxState')) || {};
        delete this.storedCheckboxState[item.patient_number];
        localStorage.setItem('checkboxState', JSON.stringify(this.storedCheckboxState));
        const visualizeClickedObj = JSON.parse(localStorage.getItem('visualizeClickedObj')) || {};
        if (visualizeClickedObj.hasOwnProperty(item.patient_number)) {
          delete visualizeClickedObj[item.patient_number];
          localStorage.setItem('visualizeClickedObj', JSON.stringify(visualizeClickedObj));
        }
        this.data.forEach((dataItem) => {
          if (dataItem.selected && dataItem.timelineGraphData) {
            this.displayGraph();
          }
        });
      } else {
        // Update the checkbox state in localStorage
        this.storedCheckboxState = JSON.parse(localStorage.getItem('checkboxState')) || {};
        this.storedCheckboxState[item.patient_number] = true;
        localStorage.setItem('checkboxState', JSON.stringify(this.storedCheckboxState));
      }
    } else {
      this.auth.refreshToken();
    }
  }

  PairingDevice(): void {
    if (this.auth.isTokenValid) {
      //this.router.navigateByUrl('connector');
      window.location.href = 'connector';
      localStorage.removeItem('hub_id');
      localStorage.removeItem('hub_description');
    } else {
      this.auth.refreshToken();
    }
  }

  displaydashboardData(): void {
    if (this.auth.isTokenValid()) {
      const params = this.buildParamsWithoutSorting();
      this.dataLoader = true;
      this.patientService.listOfPatients(params).subscribe((res) => {
        if (res?.data) {
          this.patientService.setversionData(res.Version);
          this.data = res.data.map((item) => {
            return { ...item, isSelected: false }
          });
          this.totalRows = res.totalRows
          this.updatedTime = res.TimeZone;
          this.updateWardOptions(res.wards);
          // First load builds params before the ward list is known, so if a ward
          // subset was persisted, reload once to apply it. Subsequent refreshes
          // already carry the ward filter via the ward-aware param builders.
          if (!this.wardRestoreApplied && this.getWardFilterValue() !== '') {
            this.wardRestoreApplied = true;
            this.reloadWithCurrentParams();
          } else {
            this.updatePagesArray();
          }
          this.setupAutomaticRefresh();
          this.dataLoader = false;
        } else {
          this.patientService.setversionData('');
          this.dataLoader = false;
          return;
        }

      })
    } else {
      this.auth.refreshToken();
    }
  }

  RefreshData(): void {
    if (this.auth.isTokenValid()) {
      this.displaydashboardData();
      this.setupAutomaticRefresh();
      this.updatedTime = this.updatedTime;
    } else {
      this.auth.refreshToken();
    }
  }
  sortingData(columnName: any, direction: 'asc' | 'desc') {
    if (this.auth.isTokenValid()) {
      if (columnName === this.sortColumn && direction === this.sortOrder) {
        let storedSortingParams = JSON.parse(localStorage.getItem('sortingData')) || {}
        if (storedSortingParams) {
          this.sortParams = {};
        }
        this.sortColumn = null,
          this.sortOrder = null
        localStorage.setItem('sortingData', JSON.stringify(this.sortParams));
        this.displaydashboardData();
        if (direction === 'asc') {
          this.removeBackgroundColor('asc');
        } else {
          this.removeBackgroundColor('desc');
        }
      } else {
        if (columnName === 'hub_id') {
          this.hubIdHighlighted = direction;
          this.wardHighlighted = null;
          this.BedHighlighted = null;
        } else if (columnName === 'ward') {
          this.wardHighlighted = direction;
          this.hubIdHighlighted = null;
          this.BedHighlighted = null;
        } else if (columnName === 'bed') {
          this.BedHighlighted = direction;
          this.hubIdHighlighted = null;
          this.wardHighlighted = null;
        } else if (columnName === 'datastatus') {
          this.dataHighlighted = direction;
          this.hubIdHighlighted = null;
          this.wardHighlighted = null;
          this.BedHighlighted = null;
          this.riskHighlighted = null;
        } else if (columnName === 'risk_type') {
          this.riskHighlighted = direction;
          this.hubIdHighlighted = null;
          this.wardHighlighted = null;
          this.BedHighlighted = null;
          this.dataHighlighted = null;
        }
        this.sortParams = JSON.parse(localStorage.getItem('sortingData'));
        this.sortParams = {
          sortcolumn: columnName,
          sortorder: direction
        }
        localStorage.setItem('sortingData', JSON.stringify(this.sortParams));
        this.sortColumn = columnName;
        this.sortOrder = direction;
        //Check if filter parameters is present or not, and if yes, call combined API
        if (this.previousFilterParams.filtercolumn && this.previousFilterParams.filterkey) {
          this.sendFilterAndSortParamsToApi();
        } else {
          const params = this.buildParamsWithSorting();
          this.previousSortParams = {
            sortcolumn: columnName,
            sortorder: direction
          };
          this.patientService.listOfPatients(params).subscribe((res) => {
            this.data = res.data;
            this.restoreCheckboxStates();
          })
        }
      }
    } else {
      this.auth.refreshToken();
    }
  }
  removeBackgroundColor(direction: 'asc' | 'desc') {
    if (direction === 'asc') {
      this.hubIdHighlighted = null;
      this.wardHighlighted = null;
      this.BedHighlighted = null;
      this.dataHighlighted = null;
      this.riskHighlighted = null;
    } else {
      this.hubIdHighlighted = null;
      this.wardHighlighted = null;
      this.BedHighlighted = null;
      this.dataHighlighted = null;
      this.riskHighlighted = null;
    }
  }

  buildParamsWithoutSorting() {
    if (this.auth.isTokenValid()) {
      const params = new HttpParams()
        .set('pageNumber', this.currentPage.toString())
        .set('pageSize', this.itemsPerPage.toString());
      return this.withWard(params);
    } else {
      this.auth.refreshToken();
    }
  }

  buildParamsWithSorting() {
    if (this.auth.isTokenValid()) {
      const params = new HttpParams()
        .set('pageNumber', this.currentPage.toString())
        .set('pageSize', this.itemsPerPage.toString())
        .set('sortColumn', this.sortColumn)
        .set('sortOrder', this.sortOrder);
      return this.withWard(params);
    } else {
      this.auth.refreshToken();
    }
  }

  unpairPatients(): void {
    if (this.auth.isTokenValid() && this.isDialogOpen) {
      this.isDialogOpen = true;
      this.isDropdownOpen = false;
      this.patientService.listofhubids().subscribe((res) => {
        if (this.dialog.openDialogs.length > 0) {
          this.dialog.openDialogs[this.dialog.openDialogs.length - 1].close();
        }
        this.isDialogOpen = true;
        if (res.status == 'success') {
          let hubidDataArray = res.hub_ids.map(obj => {
            let [key, value] = Object.entries(obj)[0];
            return `${key} - ${value}`;
          });
          this.hubidData = hubidDataArray;
        }
        let dialogRef: any;
        dialogRef = this.dialog.open(PatientDataboxListComponent, {
          width: '400px',
          minHeight: 'calc(100vh - 80vh)',
          maxHeight: '318px',
          height: 'auto',
          data: {
            hubIds: this.hubidData,
            yesBtn: 'Unpair',
            cancelBtn: 'Cancel',
          },
        });
        const dialogSubscriber = dialogRef?.afterClosed().subscribe((result) => {
          if (result === 'yes') {
            this.confirmationDialog();
          }
        });
      })
      this.isDialogOpen = false;
    } else {
      this.auth.refreshToken();
    }
  }

  confirmationDialog() {
    if (this.auth.isTokenValid()) {
      this.patientService.selectedHubIds.subscribe(selectedUnpair => {
        this.selectUnpiar = selectedUnpair.hub_ids;
      });
      let dialogRef: any;
      dialogRef = this.dialog.open(DialogComponent, {
        width: '477px',
        minHeight: 'calc(100vh - 80vh)',
        maxHeight: '318px',
        height: 'auto',
        data: {
          type: 'alert',
          headerImg: 'assets/images/closeIcon.png',
          buttonsAlign: 'horizantal',
          label: `${this.translate.instant('unpairdailog.label')}
            <b>${this.selectUnpiar.join('<br><br>')}</b>`,
          yesBtn: 'Confirm',
          cancelBtn: 'Cancel',
        },
      });
      const dialogSubscriber = dialogRef?.afterClosed().subscribe((result) => {
        if (result === 'yes') {
          this.patientService.selectedHubIds.subscribe(selectedCheckboxes => {
            this.hubidselection = selectedCheckboxes.hub_ids;
            this.unPairHub_id = this.hubidselection.map(result => result.substring(0, 4).trim());
          });
          let hub_ids = { hub_ids: this.unPairHub_id };
          this.patientService.unpairPatients(hub_ids).subscribe((res) => {
            this.displaydashboardData();
          })
        }
      });
    } else {
      this.auth.refreshToken();
    }
  }
  dataStatus_dropdown(dropdownName: any): void {
    if (this.auth.isTokenValid()) {
      if (this.activeDropdown === dropdownName) {
        this.isDropdownOpen = !this.isDropdownOpen;
      } else {
        this.isDropdownOpen = true;
        this.activeDropdown = dropdownName;
      }
    } else {
      this.auth.refreshToken();
    }
  }

  // --- Ward filter ("View by Ward") ---------------------------------------

  // Rebuild the ward checkbox list from the full active-ward set returned by the
  // backend (res.wards). Selections persist in localStorage; wards not yet seen
  // default to selected. Called on every load so the list stays in sync as beds
  // become active/inactive, without discarding the user's choices.
  updateWardOptions(wards: any[]) {
    if (!wards) {
      return;
    }
    const stored = JSON.parse(localStorage.getItem('selectedWardFilters')) || {};
    this.wardOptions = wards.map((name) => ({
      name,
      selected: stored.hasOwnProperty(name) ? stored[name] : true,
    }));
    this.selectedWardStatusCheckboxes = this.wardOptions.filter((w) => w.selected);
    this.selectedWardCheckboxes = this.selectedWardStatusCheckboxes.length;
  }

  // Value for the wardFilter query param: empty when every ward (or none) is
  // selected, meaning "all wards" / no filtering. A subset returns the selected
  // ward names, comma-joined.
  getWardFilterValue(): string {
    if (!this.wardOptions.length) {
      return '';
    }
    const selected = this.wardOptions.filter((w) => w.selected);
    if (selected.length === 0 || selected.length === this.wardOptions.length) {
      return '';
    }
    return selected.map((w) => w.name).join(',');
  }

  // Append the ward filter to any HttpParams so the base ward view is preserved
  // across sorting, Data/Risk filtering and pagination.
  withWard(params: any) {
    const wardValue = this.getWardFilterValue();
    return wardValue ? params.set('wardFilter', wardValue) : params;
  }

  persistWardFilters() {
    const map = {};
    this.wardOptions.forEach((w) => (map[w.name] = w.selected));
    localStorage.setItem('selectedWardFilters', JSON.stringify(map));
    this.selectedWardStatusCheckboxes = this.wardOptions.filter((w) => w.selected);
    this.selectedWardCheckboxes = this.selectedWardStatusCheckboxes.length;
  }

  selectAllWards() {
    this.wardOptions.forEach((w) => (w.selected = true));
    this.persistWardFilters();
  }

  clearAllWards() {
    this.wardOptions.forEach((w) => (w.selected = false));
    this.persistWardFilters();
  }

  applyWardFilter() {
    if (this.auth.isTokenValid()) {
      this.persistWardFilters();
      this.currentPage = 1;
      this.isDropdownOpen = false;
      this.reloadWithCurrentParams();
    } else {
      this.auth.refreshToken();
    }
  }

  // Reload the current page honouring whatever sort / Data-Risk filter state is
  // active, with the ward filter folded in via the ward-aware param builders.
  reloadWithCurrentParams() {
    if (this.auth.isTokenValid()) {
      const hasSort = this.sortColumn && this.sortOrder;
      const hasFilter = this.filterColumn && this.filterKey;
      let params;
      if (hasSort && hasFilter) {
        params = this.buildSortParamsWithFilter();
      } else if (hasSort) {
        params = this.buildParamsWithSorting();
      } else if (hasFilter) {
        params = this.buildParamsWithFiltering();
      } else {
        params = this.buildParamsWithoutSorting();
      }
      this.patientService.listOfPatients(params).subscribe((res) => {
        this.data = res.data;
        this.totalRows = res.totalRows;
        this.updateWardOptions(res.wards);
        this.pagesArray = new Array(Math.ceil(this.totalRows / this.itemsPerPage)).fill(0).map((_, index) => index + 1);
        this.restoreCheckboxStates();
      });
    } else {
      this.auth.refreshToken();
    }
  }

  handleCheckboxSelection(column: string, item: any) {
    if (this.auth.isTokenValid()) {
      if (column === 'ward') {
        this.wardFilters = JSON.parse(localStorage.getItem('selectedWardFilters')) || {};
        this.wardFilters[item.name] = item.selected;
        localStorage.setItem('selectedWardFilters', JSON.stringify(this.wardFilters));
        this.selectedWardStatusCheckboxes = this.wardOptions.filter((w) => w.selected);
        this.selectedWardCheckboxes = this.selectedWardStatusCheckboxes.length;
      } else if (column === 'datastatus') {
        if (item.selected) {
          this.selectedDataStatusCheckboxes.push(item);
          this.dataFilters = JSON.parse(localStorage.getItem('selectedDataFilters')) || {};
          this.dataFilters[item.name] = true;
        } else {
          this.dataFilters = JSON.parse(localStorage.getItem('selectedDataFilters')) || {};
          this.selectedDataStatusCheckboxes = this.selectedDataStatusCheckboxes.filter(checkbox => checkbox.name !== item.name);
          delete this.dataFilters[item.name];
        }
        localStorage.setItem('selectedDataFilters', JSON.stringify(this.dataFilters));
      } else if (column === 'risk_type') {
        if (item.selected) {
          this.selectedRiskStatusCheckboxes.push(item);
          this.riskFilters = JSON.parse(localStorage.getItem('selectedRiskFilters')) || {};
          this.riskFilters[item.name] = true;
        } else {
          this.riskFilters = JSON.parse(localStorage.getItem('selectedRiskFilters')) || {};
          this.selectedRiskStatusCheckboxes = this.selectedRiskStatusCheckboxes.filter(checkbox => checkbox.name !== item.name);
          delete this.riskFilters[item.name];
        }
        localStorage.setItem('selectedRiskFilters', JSON.stringify(this.riskFilters));
      }
    } else {
      this.auth.refreshToken();
    }
  }
  filterData(column: string, selectedCheckboxes: any[]) {
    if (this.auth.isTokenValid()) {
      this.selectedDataCheckboxes = this.selectedDataStatusCheckboxes.length;
      this.selectedRiskCheckboxes = this.selectedRiskStatusCheckboxes.length;
      let otherColumn: any;
      if (column === 'datastatus') {
        selectedCheckboxes = this.selectedDataStatusCheckboxes;
        otherColumn = 'risk_type';
      } else if (column === 'risk_type') {
        selectedCheckboxes = this.selectedRiskStatusCheckboxes;
        otherColumn = 'datastatus';
      }
      const selectedCheckboxValues = selectedCheckboxes.map(item => item.name).join(',');
      this.filterColumn = column;
      this.filterKey = selectedCheckboxValues;
      this.filterParams = {
        filtercolumn: column,
        filterkey: selectedCheckboxValues
      }
      const params = this.buildParamsWithFiltering();
      this.previousFilterParams = {
        filtercolumn: this.filterParams.filtercolumn,
        filterkey: this.filterParams.filterkey
      };
      this.filtersApplied = true;
      this.patientService.listOfPatients(params).subscribe((res) => {
        this.data = res.data;
        this.totalRows = res.totalRows;
        this.pagesArray = new Array(Math.ceil(this.totalRows / this.itemsPerPage)).fill(0).map((_, index) => index + 1);
        this.currentPage = 1;
        this.updatePagesArray();
        this.restoreCheckboxStates();

        if (selectedCheckboxes.length === 0) {
          this.filterColumn = null;
          this.filterKey = null;
          this.filterParams = null;
          this.filtersApplied = false;
          if (this.selectedCheckboxesForColumn(otherColumn).length > 0) {
            this.filterData(otherColumn, selectedCheckboxes);
          } else {
            this.displaydashboardData();
          }

          if (column === 'datastatus') {
            this.isDropdownOpen = false;
          } else if (column === 'risk_type') {
            this.isDropdownOpen = false;
          }
        }
      });
      this.isDropdownOpen = false;
      if (this.selectedDataStatusCheckboxes.length == 0 && this.selectedRiskStatusCheckboxes.length == 0) {
        this.isDropdownOpen = false;
        this.displaydashboardData();
      }
    } else {
      this.auth.refreshToken();
    }
  }

  selectedCheckboxesForColumn(column: string): any[] {
    if (column === 'datastatus') {
      return this.selectedDataStatusCheckboxes;
    } else if (column === 'risk_type') {
      return this.selectedRiskStatusCheckboxes;
    }

    return [];
  }

  buildParamsWithFiltering() {
    if (this.auth.isTokenValid()) {
      const params = new HttpParams()
        .set('pageNumber', this.currentPage.toString())
        .set('pageSize', this.itemsPerPage.toString())
        .set('filterColumn', this.filterColumn)
        .set('filterKey', this.filterKey);
      return this.withWard(params);
    } else {
      this.auth.refreshToken();
    }
  }

  buildSortParamsWithFilter() {
    if (this.auth.isTokenValid()) {
      let params = new HttpParams()
        .set('pageNumber', this.currentPage.toString())
        .set('pageSize', this.itemsPerPage.toString());

      if (this.filterParams.filtercolumn && this.filterParams.filterkey) {
        params = params
          .set('filterColumn', this.filterParams.filtercolumn)
          .set('filterKey', this.filterParams.filterkey);

        this.previousFilterParams = { ...this.filterParams };
      } else if (this.previousFilterParams.filtercolumn && this.previousFilterParams.filterkey) {
        params = params
          .set('filterColumn', this.previousFilterParams.filtercolumn)
          .set('filterKey', this.previousFilterParams.filterkey);
      }

      if (this.sortParams.sortcolumn && this.sortParams.sortorder) {
        params = params
          .set('sortColumn', this.sortParams.sortcolumn)
          .set('sortOrder', this.sortParams.sortorder);

        this.previousSortParams = { ...this.sortParams };
      }
      return this.withWard(params);
    }
  }

  sendFilterAndSortParamsToApi() {
    if (this.auth.isTokenValid()) {
      let params = this.buildSortParamsWithFilter();
      if (this.filterParams.filtercolumn && this.filterParams.filterkey) {
        this.patientService.listOfPatients(params).subscribe((res) => {
          this.data = res.data;
          this.totalRows = res.totalRows;
          this.pagesArray = new Array(Math.ceil(this.totalRows / this.itemsPerPage)).fill(0).map((_, index) => index + 1);
          this.restoreCheckboxStates();
        });
      }
    } else {
      this.auth.refreshToken();
    }
  }
  closeFilter() {
    if (this.auth.isTokenValid()) {
      this.isDropdownOpen = false;
    } else {
      this.auth.refreshToken(this.routerStateSnapshot.url);
    }
  }
  displayGraph() {
    if (this.auth.isTokenValid()) {
      this.displayTimeline = true;
      this.selectedItems = this.data.filter(item => {
        if (item.selected) {
          item.isSelected = true;
          const visualizeClickedObj = JSON.parse(localStorage.getItem('visualizeClickedObj')) || {};
          visualizeClickedObj[item.patient_number] = {
            isSelected: item.isSelected,
          };
          localStorage.setItem('visualizeClickedObj', JSON.stringify(visualizeClickedObj));
        }
        return item.selected;
      });
      const selectedValue: any = [] = this.selectedItems.map((item) => item.patient_number).join(',');
      const params = new HttpParams()
        .set('patient_numbers', selectedValue)
      this.patientService.graphData(params).subscribe((res) => {
        this.data = this.data.map((item) => {
          let timelineGraphData = res[item?.patient_number];
          if (timelineGraphData) {
            item.timelineGraphData = timelineGraphData;
            let timeGraph = timelineGraphData.Timezone;
            this.formattingTime = this.formatData(item.patient_number.split('-')[1], timeGraph);
            item.timeGraphId = this.formattingTime;
          }
          return item;
        });
      })
    } else {
      this.auth.refreshToken();
    }
  }

  formatData(patient, timezone) {
    let patientBed = patient.substring(0, 3)
    let patientValue = patient.substring(3)
    let [, datePart, timePart, timeZoneAbbreviation] = timezone.match(/(\d{4}-\d{2}-\d{2}), (\d{2}:\d{2}:\d{2}) ([\w+\-]+)/) || [];

    // Format the result
    let convertFormat = `${patientBed} ${patientValue}: ${timeZoneAbbreviation} ${datePart}_${timePart}`;
    return convertFormat;
  }

  closeAllgraphs() {
    if (this.auth.isTokenValid()) {
      this.displayTimeline = false;
      this.data = this.data.map(item => {
        item.timelineGraphData = null;
        item.selected = false;
        item.isSelected = false;
        this.storedCheckboxState = JSON.parse(localStorage.getItem('checkboxState')) || {};
        delete this.storedCheckboxState[item.patient_number];
        localStorage.setItem('checkboxState', JSON.stringify(this.storedCheckboxState));
        const visualizeClickedObj = JSON.parse(localStorage.getItem('visualizeClickedObj')) || {};
        delete visualizeClickedObj[item.patient_number];
        localStorage.setItem('visualizeClickedObj', JSON.stringify(visualizeClickedObj));
        return item;
      });
    } else {
      this.auth.refreshToken();
    }
  }


  previousPage() {
    if (this.auth.isTokenValid()) {
      if (this.currentPage > 1) {
        this.goToPage(this.currentPage - 1);
        if (this.sortColumn && this.sortOrder && this.filterColumn && this.filterKey) {
          const params = this.sortColumn && this.sortOrder && this.filterColumn && this.filterKey
            ? this.buildSortParamsWithFilter()
            : this.buildParamsWithoutSorting();
          this.patientService.listOfPatients(params).subscribe((res) => {
            this.data = res.data;
            this.totalRows = res.totalRows;
            this.pagesArray = new Array(Math.ceil(this.totalRows / this.itemsPerPage)).fill(0).map((_, index) => index + 1);
            this.restoreCheckboxStates();
          });
        } else if (this.sortColumn && this.sortOrder) {
          const params = this.sortColumn && this.sortOrder ? this.buildParamsWithSorting() : this.buildParamsWithoutSorting();
          this.patientService.listOfPatients(params).subscribe((res) => {
            this.data = res.data;
            this.restoreCheckboxStates();
          });
        } else if (this.filterColumn && this.filterKey) {
          const params = this.filterColumn && this.filterKey ? this.buildParamsWithFiltering() : this.buildParamsWithoutSorting();
          this.patientService.listOfPatients(params).subscribe((res) => {
            this.data = res.data;
            this.totalRows = res.totalRows;
            this.pagesArray = new Array(Math.ceil(this.totalRows / this.itemsPerPage)).fill(0).map((_, index) => index + 1);
            this.restoreCheckboxStates();
          });
        } else {
          this.restoreCheckboxStates();
        }
      }
    } else {
      this.auth.refreshToken();
    }
  }

  nextPage() {
    if (this.auth.isTokenValid()) {
      if (this.currentPage < this.totalPages) {
        this.goToPage(this.currentPage + 1);
        if (this.sortColumn && this.sortOrder && this.filterColumn && this.filterKey) {
          const params = this.sortColumn && this.sortOrder && this.filterColumn && this.filterKey
            ? this.buildSortParamsWithFilter()
            : this.buildParamsWithoutSorting();
          this.patientService.listOfPatients(params).subscribe((res) => {
            this.data = res.data;
            this.totalRows = res.totalRows;
            this.pagesArray = new Array(Math.ceil(this.totalRows / this.itemsPerPage)).fill(0).map((_, index) => index + 1);
            this.restoreCheckboxStates();
          });
        } else if (this.sortColumn && this.sortOrder) {
          const params = this.sortColumn && this.sortOrder ? this.buildParamsWithSorting() : this.buildParamsWithoutSorting();
          this.patientService.listOfPatients(params).subscribe((res) => {
            this.data = res.data;
            this.restoreCheckboxStates();
          });
        } else if (this.filterColumn && this.filterKey) {
          const params = this.filterColumn && this.filterKey ? this.buildParamsWithFiltering() : this.buildParamsWithoutSorting();
          this.patientService.listOfPatients(params).subscribe((res) => {
            this.data = res.data;
            this.totalRows = res.totalRows;
            this.pagesArray = new Array(Math.ceil(this.totalRows / this.itemsPerPage)).fill(0).map((_, index) => index + 1);
            this.restoreCheckboxStates();
          });
        } else {
          this.restoreCheckboxStates();
        }
      }
    } else {
      this.auth.refreshToken();
    }
  }

  get totalPages() {
    if (this.auth.isTokenValid()) {
      return Math.ceil(this.totalRows / this.itemsPerPage);
    } else {
      this.auth.refreshToken();
    }
  }

  updatePagesArray() {
    if (this.auth.isTokenValid()) {
      this.pagesArray = new Array(Math.ceil(this.totalRows / this.itemsPerPage)).fill(0).map((_, index) => index + 1);
      if (this.sortColumn && this.sortOrder && this.filterColumn && this.filterKey) {
        const params = this.sortColumn && this.sortOrder && this.filterColumn && this.filterKey
          ? this.buildSortParamsWithFilter()
          : this.buildParamsWithoutSorting();
        this.patientService.listOfPatients(params).subscribe((res) => {
          this.data = res.data;
          this.totalRows = res.totalRows;
          this.pagesArray = new Array(Math.ceil(this.totalRows / this.itemsPerPage)).fill(0).map((_, index) => index + 1);
          this.restoreCheckboxStates();
        });
      } else if (this.sortColumn && this.sortOrder) {
        const params = this.sortColumn && this.sortOrder ? this.buildParamsWithSorting() : this.buildParamsWithoutSorting();
        this.patientService.listOfPatients(params).subscribe((res) => {
          this.data = res.data;
          this.restoreCheckboxStates();
        });
      } else if (this.filterColumn && this.filterKey) {
        const params = this.filterColumn && this.filterKey ? this.buildParamsWithFiltering() : this.buildParamsWithoutSorting();
        this.patientService.listOfPatients(params).subscribe((res) => {
          this.data = res.data;
          this.totalRows = res.totalRows;
          this.pagesArray = new Array(Math.ceil(this.totalRows / this.itemsPerPage)).fill(0).map((_, index) => index + 1);
          this.restoreCheckboxStates();
        });
      } else {
        this.restoreCheckboxStates();
      }
    } else {
      this.auth.refreshToken();
    }
  }

  goToPage(page: number) {
    if (this.auth.isTokenValid()) {
      if (page >= 1 && page <= this.totalPages) {
        this.currentPage = page;
        this.displaydashboardData();
      }
    } else {
      this.auth.refreshToken();
    }
  }
  getColor(riskStatus: string): string {
    if (riskStatus === 'Mid Risk') {
      return 'yellow';
    } else if (riskStatus === 'High Risk') {
      return 'red';
    } else if (riskStatus === 'No Risk') {
      return 'green';
    } else if (riskStatus === 'Out Of Bed') {
      return 'grey';
    } else if (riskStatus === 'Check Sensor Cable') {
      return 'light_red';
    }
  }
  ngOnDestroy() {
    if (this.auth.isTokenValid()) {
      if (this.dataSubscription) {
        this.dataSubscription.unsubscribe();
      }
    } else {
      this.auth.refreshToken();
    }
  }
}